import React from 'react';

export function StatusColumnFormatter(cellContent) {
  const {statusID, statusName} = cellContent;
  switch (statusID) {
    case 2:
      return (
        <div
          className="badge badge-pill w-100px font-size-h4 text-nowrap"
          style={{
            background: '#F2E6E6',
            border: '1px solid rgb(239, 65, 48)',
            color: 'rgb(239, 65, 48)',
          }}
        >
          {statusName}
        </div>
      );
    case 1:
      return (
        <div
          className="badge badge-pill w-100px font-size-h4 text-nowrap"
          style={{
            background: '#CDEADB',
            border: '1px solid rgb(65, 141, 88)',
            color: 'rgb(65, 141, 88)',
          }}
        >
          {statusName}
        </div>
      );
    default:
      return null;
  }
}
